import version from './version?text';
export { version };

import SyntaxError from '.SyntaxError';
import RegExp from '.RegExp';
import isArray from '.Array.isArray?=';
import test from '.RegExp.prototype.test';
import bind from '.Function.prototype.bind?';
import undefined from '.undefined';

import { groupify, clearRegExp } from '@ltd/j-regexp';

var test_bind = bind
	? /*#__PURE__*/bind.bind(test)                                                                           
	: function (            regExp        ) { return function (            string        ) { return regExp.test(string); }; };

var toggleGlobal = 'flags' in RegExp.prototype
	? function toggleGlobal (regExp        , global         ) {
		return regExp.global===global ? regExp : RegExp(regExp, global ? 'g' + regExp.flags : regExp.flags.replace('g', ''));
	}
	: function toggleGlobal (regExp        , global         ) {
		if ( regExp.global===global ) { return regExp; }
		var literal = '' + regExp;
		var flags = literal.slice(literal.lastIndexOf('/') + 1);
		return RegExp(regExp.source, global ? 'g' + flags : flags.replace('g', ''));
	};

export function EOL                     (allow                         , uniform          , disallow                             ) {
	
	var ALLOW = /*#__PURE__*/isArray(allow)
		? /*#__PURE__*/RegExp(/*#__PURE__*/groupify(allow), uniform ? 'g' : '')
		: uniform===undefined
			? ( uniform = allow.global, allow )
			: /*#__PURE__*/toggleGlobal(allow, !!uniform);
	
	if ( disallow ) {
		var testDisallow = /*#__PURE__*/test_bind(
			/*#__PURE__*/isArray(disallow)
				? /*#__PURE__*/RegExp(groupify(disallow))
				: /*#__PURE__*/toggleGlobal(disallow, false)
		);
		return uniform
			? function EOL (string        )           {
				if ( testDisallow(string) ) { throw clearRegExp(SyntaxError('存在禁用换行符')); }
				var eols = clearRegExp(string.match(ALLOW)                );
				if ( !eols ) { return ''; }
				var eol = eols[0] ;
				for ( var length = eols.length, index = 1; index!==length; ++index ) { if ( eols[index]!==eol ) { throw SyntaxError('存在多种换行符'); } }
				return eol;
			}
			: function EOL (string        )           {
				if ( testDisallow(string) ) { throw clearRegExp(SyntaxError('存在禁用换行符')); }
				var eols = clearRegExp(string.match(ALLOW)                );
				return eols ? eols[0]  : '';
			};
	}
	else {
		return uniform
			? function EOL (string        )           {
				var eols = clearRegExp(string.match(ALLOW)                );
				if ( !eols ) { return ''; }
				var eol = eols[0] ;
				for ( var length = eols.length, index = 1; index!==length; ++index ) { if ( eols[index]!==eol ) { throw SyntaxError('存在多种换行符'); } }
				return eol;
			}
			: function EOL (string        )           {
				var eols = clearRegExp(string.match(ALLOW)                );
				return eols ? eols[0]  : '';
			};
	}
	
}

export var LF     = '\n';
export var VT     = '\x0B';
export var FF     = '\f';
export var CRLF       = '\r\n';
export var CR     = '\r';
export var NEL      = '\x85';
export var LS     = '\u2028';
export var PS     = '\u2029';

                      
                        
                      
                          
                      
                         
                          
                          

export var ES = /\n|\r\n?|[\u2028\u2029]/g;
export var CSS = /\n|\r\n?|\f/g;
export var XML = /\n|\r[\n\x85\u2028]?|[\x85\u2028]/g;
export var HTML = /\n|\r\n?/g;
export var TOML = /\n|\r\n/g;

import Default from '.default?=';
export default Default(EOL, {
	version: version,
	EOL: EOL,
	LF: LF,
	VT: VT,
	FF: FF,
	CRLF: CRLF,
	CR: CR,
	NEL: NEL,
	LS: LS,
	PS: PS
});
